import swiperUtil from '../utils/swiper-util';

export default (node) => {
  /**
   * Data + elements
   */
  const swiperNode = node.querySelector('[data-swiper]');
  const buttonNext = node.querySelector('[data-next]');
  const buttonPrev = node.querySelector('[data-prev]');

  /**
   * Functions
   */
  const initSwiper = () => {
    const swiperEl = swiperUtil(swiperNode, {
      spaceBetween: 0,
      slidesPerView: 1.5,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.8,
        },
        1024: {
          slidesPerView: 4.2,
        },
      },
    });
  };

  /**
   * Init
   */
  const init = () => {
    if (swiperNode) initSwiper();
  };

  init();
};
